module.exports = __webpack_public_path__ + "static/img/index.98ea3271.png";